<template>
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1118.5 122.24">
		<title>mobile top bar ridge</title>
		<g id="Layer_2" data-name="Layer 2">
			<g id="Layer_1-2" data-name="Layer 1">
				<path
					d="M1118.5,0H0V117.53c6.42-6.28,19.27-6.28,25.7,0s19.27,6.28,25.69,0,19.27-6.28,25.7,0,19.27,6.28,25.69,0,19.27-6.28,25.7,0,19.27,6.28,25.69,0,19.27-6.28,25.7,0,19.27,6.28,25.69,0,19.27-6.28,25.7,0,19.27,6.28,25.69,0,19.27-6.28,25.7,0,19.27,6.28,25.69,0,19.27-6.28,25.7,0,19.27,6.28,25.69,0,19.27-6.28,25.7,0,19.27,6.28,25.69,0,19.27-6.28,25.7,0,19.27,6.28,25.69,0,19.27-6.28,25.7,0,19.27,6.28,25.69,0,19.28-6.28,25.7,0,19.27,6.28,25.69,0,19.28-6.28,25.7,0,19.27,6.28,25.69,0,19.28-6.28,25.7,0,19.27,6.28,25.69,0,19.28-6.28,25.7,0,19.27,6.28,25.7,0,19.27-6.28,25.69,0,19.27,6.28,25.7,0,19.27-6.28,25.69,0,19.27,6.28,25.7,0,19.27-6.28,25.69,0,19.27,6.28,25.7,0,19.27-6.28,25.69,0,19.27,6.28,25.7,0,19.27-6.28,25.69,0,19.27,6.28,25.7,0,19.27-6.28,25.69,0,19.27,6.28,25.7,0,19.27-6.28,25.69,0,19.27,6.28,25.7,0,19.27-6.28,25.69,0c3.38,3.31,8.54,4.85,13.61,4.68Z"
				/>
			</g>
		</g>
	</svg>
</template>

<script>
	export default {
		name: "BottomRidge"
	};
</script>

<style lang="scss" scoped>
	#Layer_2 {
		fill: #fff;
	}

	@media (min-width: $breakpoint-small) {
		svg {
			display: none;
		}
	}
</style>
